module.exports = __webpack_public_path__ + "img/Atelier_4.951bc215.jpg";